import { IconTokens, ListTypeTokens, } from '@voltmoney/schema';
export const args = {
    data: [
        {
            label: 'Axis Long Term Equity Mutual Funds',
            info: '',
            trailTitle: '₹4,000',
            trailSubTitle: '/ ₹4,000',
            trailIcon: {
                name: IconTokens.Edit,
            },
            action: 'edit',
            secondaryText: 'Portfolio value: ₹100,000',
        },
        {
            label: 'Axis Long Term Equity Mutual Funds',
            info: '',
            trailTitle: '₹4,000',
            trailSubTitle: '/ ₹4,000',
            action: 'edit',
            secondaryText: 'Portfolio value: ₹100,000',
        },
        {
            label: 'Axis Long Term Equity Mutual Funds',
            info: '',
            trailTitle: '₹4,000',
            trailSubTitle: '/ ₹4,000',
            action: 'edit',
        },
        {
            label: 'Axis Long Term Equity Mutual Funds',
            info: '',
            trailTitle: '₹4,000',
            trailSubTitle: '/ ₹4,000',
            action: 'edit',
        },
    ],
    type: ListTypeTokens.CHECKLIST,
    hideCheck: true,
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(ListTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
